// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nbutton.btn-sm[data-v-16dcdae8] \n  {\n    font-size: 13px;\n    padding-left: 5px;\n    padding-right: 5px;\n    padding-top: 2px;\n    padding-bottom: 2px;\n    border: solid 1px rgb(204,204,204);\n}\ninput.form-control[data-v-16dcdae8] \n  {\n    margin-left: 0.5em;\n}\ninput.quick-search[data-v-16dcdae8] {\n    border-radius: 4px !important;\n}\n\n", ""]);
// Exports
module.exports = exports;
